import React,{useState} from 'react';
//import Container from 'olive-react-myoneui/lib/Container';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
//import CourseBlock from './CourseBlock';
import CourseBundleDescription from './CourseBundleDescription';
import CourseCarousel from './CourseCarousel';
import EventCarousel from './EventCarousel';
import ReviewsAndRatings from "./ReviewAndRatings";
import TrainingCourseCarousel from './TrainingCourseCarousel';

function CoursesListSlide({ coursedetails }) {
  return (
    <div>
      <>
        <Row className="align-items-center">
          <Col md={12} xl={12}>
            <div className="mk-bundle-courses mk-scroll-horizontal carousel-course-bundle mk-res-bundle-courses">
              <CourseCarousel coursedetails={coursedetails} />
              <EventCarousel coursedetails={coursedetails} />
              <TrainingCourseCarousel coursedetails={coursedetails} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="mb-4">
            <CourseBundleDescription
              className="mt-4 mb-4"
              courseBundleDescTitle="Description for bundle"
              courseBundleDesc={coursedetails?.bundle?.c_description}
            />
          </Col>
          {coursedetails?.bundle.course_reviews.reviews.length > 0 && coursedetails?.bundle.c_rating_enabled == "1" &&
          <ReviewsAndRatings coursedetails = {coursedetails}/>
          }
        </Row>
      </>
    </div>
  );
}

export default CoursesListSlide;
